import { LEGAL_OPERATOR, LEGAL_SITE, YOOKASSA } from "./legalMeta";

export const OFERTA_SECTIONS = [
  {
    key: "general",
    title: "Общие положения",
    summary: "Договор на оказание цифровых услуг платформы MOGAME.",
    data: [
      {
        point: 1,
        text: `Настоящий документ является официальным предложением (${LEGAL_OPERATOR.status} ${LEGAL_OPERATOR.name}, ИНН ${LEGAL_OPERATOR.inn}, далее — «Исполнитель») заключить договор на оказание услуг на условиях, изложенных ниже.`,
      },
      {
        point: 2,
        text: `Документ опубликован на сайте ${LEGAL_SITE.url} и адресован пользователям сервиса ${LEGAL_SITE.name} (далее — «Пользователь», «Сайт»).`,
      },
      {
        point: 3,
        text: "Исполнитель оказывает услуги по предоставлению доступа к функционалу платформы для создания и распространения интерактивных сценариев в Telegram.",
      },
    ],
  },
  {
    key: "terms",
    title: "Термины и определения",
    summary: "Основные понятия, используемые в оферте.",
    data: [
      {
        point: 1,
        text: "Аккаунт — учётная запись Пользователя на Сайте, созданная при регистрации.",
      },
      {
        point: 2,
        text: "Групповой доступ — режим прохождения сценария сотрудниками компании по общей ссылке в Telegram без персональных ключей.",
      },
      {
        point: 3,
        text: "Бизнес-подписка — платный доступ к групповому режиму и аналитике прохождений на срок и с лимитом сотрудников согласно выбранному тарифу.",
      },
      {
        point: 4,
        text: `Платёжный провайдер — ${YOOKASSA.name}, через которого осуществляется приём платежей.`,
      },
    ],
  },
  {
    key: "subject",
    title: "Предмет договора",
    summary: "Что именно получает Пользователь после оплаты.",
    data: [
      {
        point: 1,
        text: "Исполнитель предоставляет Пользователю доступ к платному функционалу Сайта, а Пользователь обязуется оплатить услуги в порядке и на условиях настоящей оферты.",
      },
      {
        point: 2,
        text: "Состав, объём и стоимость услуг определяются описанием тарифа или пакета на странице оплаты на момент совершения платежа.",
      },
      {
        point: 3,
        text: "Услуги считаются оказанными с момента зачисления оплаченного цифрового продукта на Аккаунт Пользователя.",
      },
    ],
  },
  {
    key: "acceptance",
    title: "Порядок акцепта оферты",
    summary: "Как Пользователь принимает условия договора.",
    data: [
      {
        point: 1,
        text: "Акцептом оферты считается регистрация на Сайте, оформление и оплата заказа, а также нажатие кнопок «Купить», «Оплатить» или аналогичных.",
      },
      {
        point: 2,
        text: "Совершая акцепт, Пользователь подтверждает, что ознакомился с офертой, Правилами сервиса и Политикой конфиденциальности.",
      },
      {
        point: 3,
        text: "Договор считается заключённым с момента успешного подтверждения оплаты платёжной системой.",
      },
    ],
  },
  {
    key: "payment",
    title: "Стоимость и порядок оплаты",
    summary: "Цены, валюта и платёжный партнёр.",
    data: [
      {
        point: 1,
        text: "Стоимость услуг указывается на Сайте в рублях РФ и включает все обязательные платежи, если иное не указано отдельно.",
      },
      {
        point: 2,
        text: `Оплата осуществляется через платёжного провайдера ${YOOKASSA.name} (${YOOKASSA.legalName}).`,
      },
      {
        point: 3,
        text: "Исполнитель применяет налог на профессиональный доход (НПД) в порядке, установленном законодательством РФ.",
      },
      {
        point: 4,
        text: "Моментом оплаты считается получение подтверждения успешной транзакции от платёжной системы.",
      },
      {
        point: 5,
        text: "Пользователь соглашается с правилами и тарифами платёжного провайдера при использовании его сервиса.",
      },
    ],
  },
  {
    key: "delivery",
    title: "Порядок оказания услуг",
    summary: "Когда и как предоставляется доступ.",
    data: [
      {
        point: 1,
        text: "После подтверждения оплаты цифровой продукт зачисляется на Аккаунт Пользователя автоматически.",
      },
      {
        point: 2,
        text: "Уведомление о зачислении может направляться на email, указанный при регистрации.",
      },
      {
        point: 3,
        text: "Исполнитель обеспечивает работоспособность Сайта в рамках разумных технических возможностей, за исключением периодов профилактики и сбоев сторонних сервисов.",
      },
    ],
  },
  {
    key: "refund",
    title: "Возврат средств",
    summary: "Условия возврата в соответствии с законодательством РФ.",
    data: [
      {
        point: 1,
        text: "Возврат осуществляется через платёжную систему в соответствии с её правилами и законодательством РФ о защите прав потребителей.",
      },
      {
        point: 2,
        text: "Возврат возможен при технической ошибке оплаты, двойном списании или невозможности оказать услугу по вине Исполнителя.",
      },
      {
        point: 3,
        text: "Цифровые услуги и ключи доступа надлежащего качества, фактически предоставленные Пользователю, возврату не подлежат, за исключением случаев, прямо предусмотренных законом.",
      },
      {
        point: 4,
        text: `Запрос на возврат направляется на ${LEGAL_OPERATOR.email} с указанием email аккаунта, даты и суммы платежа.`,
      },
    ],
  },
  {
    key: "liability",
    title: "Ответственность сторон",
    summary: "Ограничения ответственности Исполнителя.",
    data: [
      {
        point: 1,
        text: "Исполнитель не несёт ответственности за сбои в работе платёжных систем, банков, Telegram и иных сервисов третьих лиц.",
      },
      {
        point: 2,
        text: "Исполнитель не отвечает за ошибки при вводе платёжных данных Пользователем.",
      },
      {
        point: 3,
        text: "Пользователь несёт ответственность за достоверность указанных при регистрации данных и за контент, создаваемый с использованием Сайта.",
      },
    ],
  },
  {
    key: "ip",
    title: "Интеллектуальная собственность",
    summary: "Права на платформу и пользовательский контент.",
    data: [
      {
        point: 1,
        text: "Права на программное обеспечение, дизайн и элементы интерфейса Сайта принадлежат Исполнителю или правообладателям, предоставившим соответствующую лицензию.",
      },
      {
        point: 2,
        text: "Пользователь сохраняет права на созданные им сценарии и предоставляет Исполнителю неисключительную лицензию на их хранение и обработку в рамках работы Сайта.",
      },
    ],
  },
  {
    key: "personal-data",
    title: "Персональные данные",
    summary: "Обработка данных при исполнении договора.",
    data: [
      {
        point: 1,
        text: "Исполнитель обрабатывает персональные данные в соответствии с Федеральным законом № 152-ФЗ «О персональных данных».",
      },
      {
        point: 2,
        text: "Подробный порядок обработки персональных данных изложен в Политике конфиденциальности на Сайте.",
      },
      {
        point: 3,
        text: "При оплате через ЮKassa обработка платёжных данных осуществляется в соответствии с политикой конфиденциальности платёжного провайдера.",
      },
    ],
  },
  {
    key: "requisites",
    title: "Реквизиты Исполнителя",
    summary: "Контактные и идентификационные данные.",
    data: [
      {
        point: 1,
        text: `Исполнитель: ${LEGAL_OPERATOR.status} ${LEGAL_OPERATOR.name}, ИНН ${LEGAL_OPERATOR.inn}.`,
      },
      {
        point: 2,
        text: `Email: ${LEGAL_OPERATOR.email}. Telegram: ${LEGAL_OPERATOR.telegram}.`,
      },
      {
        point: 3,
        text: `Платёжный провайдер: ${YOOKASSA.legalName}, ИНН ${YOOKASSA.inn}, ОГРН ${YOOKASSA.ogrn}, ${YOOKASSA.address}.`,
      },
    ],
  },
  {
    key: "final",
    title: "Заключительные положения",
    summary: "Применимое право и изменение условий.",
    data: [
      {
        point: 1,
        text: "Настоящая оферта регулируется законодательством Российской Федерации.",
      },
      {
        point: 2,
        text: "Споры разрешаются путём переговоров, а при недостижении согласия — в суде по месту регистрации Исполнителя, если иное не предусмотрено императивными нормами.",
      },
      {
        point: 3,
        text: "Исполнитель вправе изменять условия оферты с публикацией новой редакции на Сайте. Действующая редакция доступна по адресу /oferta.",
      },
    ],
  },
];
